import React, { createContext, useContext, useState, useEffect } from 'react';
import {
  subscribeToContactInfo,
  subscribeToSocialMedia,
  subscribeToSectionSettings,
} from '../services/firestore';

const SettingsContext = createContext(undefined);

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

// Default values in case settings aren't loaded yet
const defaultContactInfo = {
  phone: '',
  whatsapp: '6289526775445',
  email: 'putrileony.office@gmail.com',
  address: 'Padasuka, Sumedang Utara',
  city: 'Sumedang',
  region: 'Jawa Barat',
  postalCode: '',
  mapUrl: '',
};

const defaultSocialMedia = {
  instagram: 'https://instagram.com/tehputri_henna',
  facebook: 'https://facebook.com/tehputrihenna',
  tiktok: 'https://tiktok.com/@tehputrihenna',
  twitter: '',
  youtube: '',
};

const defaultSectionSettings = {
  hero: true,
  about: true,
  services: true,
  gallery: true,
  certificates: true,
  testimonials: true,
  contact: true,
};

export const SettingsProvider = ({ children }) => {
  const [contactInfo, setContactInfo] = useState(defaultContactInfo);
  const [socialMedia, setSocialMedia] = useState(defaultSocialMedia);
  const [sectionSettings, setSectionSettings] = useState(defaultSectionSettings);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribeContact = subscribeToContactInfo((data) => {
      if (data && Object.keys(data).length > 0) {
        setContactInfo((prev) => ({ ...prev, ...data }));
      }
    });

    const unsubscribeSocial = subscribeToSocialMedia((data) => {
      if (data && Object.keys(data).length > 0) {
        setSocialMedia((prev) => ({ ...prev, ...data }));
      }
    });

    const unsubscribeSections = subscribeToSectionSettings((data) => {
      if (data && Object.keys(data).length > 0) {
        setSectionSettings((prev) => ({ ...prev, ...data }));
      }
      setLoading(false);
    });

    // Set loading to false after a timeout even if no data
    const timeout = setTimeout(() => setLoading(false), 2000);

    return () => {
      unsubscribeContact();
      unsubscribeSocial();
      unsubscribeSections();
      clearTimeout(timeout);
    };
  }, []);

  const value = {
    contactInfo,
    socialMedia,
    sectionSettings,
    loading,
  };

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
};
